export const application = 'academy-local';

export const apiURL = 'http://localhost:5200/bright/api'; // config for local backend

export const vimeoURL = 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com';
